import ProfilNCBContent from "../../components/layouts/tentang/ProfilNCBContent";

import React from "react";

const ProfilNCB: React.FC = () => {
  return (
    <div>
      <ProfilNCBContent />
    </div>
  );
};

export default ProfilNCB;
